import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Icon from './Icon';
import Path from './Path';
var STATUS_VARIANTS = {
  confirmed: ['checkmark-circle', 'success'],
  unconfirmed: ['question-circle', 'warning'],
  declined: ['close-circle', 'error']
};

function Status(props) {
  var color = props.color,
      variant = props.variant,
      variantFilled = props.variantFilled,
      restProps = _objectWithoutPropertiesLoose(props, ["color", "variant", "variantFilled"]);

  var variantName;
  var variantColor;
  Object.keys(STATUS_VARIANTS).some(function (key) {
    var _STATUS_VARIANTS$key;

    return variant === key ? (_STATUS_VARIANTS$key = STATUS_VARIANTS[key], variantName = _STATUS_VARIANTS$key[0], variantColor = _STATUS_VARIANTS$key[1], _STATUS_VARIANTS$key) : false;
  });

  if (variantName && variantFilled) {
    variantName += '-filled';
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    name: variantName,
    color: color || variantColor
  }, restProps), /*#__PURE__*/React.createElement(Path, {
    name: "radio-0",
    color: color
  }));
}

export default Status;